import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5c307218&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c307218",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c307218')) {
      api.createRecord('5c307218', component.options)
    } else {
      api.reload('5c307218', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5c307218&scoped=true", function () {
      api.rerender('5c307218', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/roleManage/index.vue"
export default component.exports